/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { notificationConditionTypeEnumSchema } from "./notificationConditionTypeEnumSchema.ts";
import { pushSendDateModelSchema } from "./pushSendDateModelSchema.ts";
import { pushTypeEnumSchema } from "./pushTypeEnumSchema.ts";
import { z } from "zod";

export const createOrUpdateNotificationModelSchema = z.object({
    "name": z.string().max(150).describe("Заголовок"),
"description": z.string().max(1000).describe("Описание"),
"conditionType": z.lazy(() => notificationConditionTypeEnumSchema).describe("<p>Возможные значения:</p>\n<ul>\n<li><b>1 - Instant</b>: Моментально всем</li>\n<li><b>2 - AtTime</b>: В указанное время</li>\n</ul>\n"),
"pictureFileId": z.string().uuid().describe("Идентификатор файла-обложки").nullable().nullish(),
"sendOnDate": z.string().datetime({ offset: true }).describe("Дата отправки в UTC").nullable().nullish(),
"dates": z.array(z.lazy(() => pushSendDateModelSchema)).describe("Даты отправки").nullable().nullish(),
"pushType": z.lazy(() => pushTypeEnumSchema).nullable().nullish()
    })